import { memo } from 'react';

import { CustomFieldTypeName } from '@air/api/types';

import {
  BaseCustomFieldFilterCard,
  type BaseCustomFieldFilterCardProps,
} from '~/components/Filters/CustomFieldFilter/BaseCustomFieldFilterCard';
import { DateCustomFieldFilterCard } from '~/components/Filters/CustomFieldFilter/DateCustomFieldFilterCard';
import { PlainTextCustomFieldFilterCard } from '~/components/Filters/CustomFieldFilter/PlainTextCustomFieldFilterCard';
import { type CustomFieldFilterType } from '~/components/FiltersMenu/types';
import { useGetPublicCustomFieldOptions } from '~/swr-hooks/customFields/useGetPublicCustomFieldOptions';

export type PublicCustomFieldFilterCardProps = {
  customField: CustomFieldFilterType;
} & Omit<BaseCustomFieldFilterCardProps, 'values'>;

const PublicSelectCustomFieldFilterCard = memo(({ customField, ...props }: PublicCustomFieldFilterCardProps) => {
  const { data } = useGetPublicCustomFieldOptions({
    customFieldId: customField.id,
  });

  return <BaseCustomFieldFilterCard values={data?.data ?? []} customField={customField} {...props} />;
});

PublicSelectCustomFieldFilterCard.displayName = 'PublicSelectCustomFieldFilterCard';

export const PublicCustomFieldFilterCard = memo((props: PublicCustomFieldFilterCardProps) => {
  if (props.customField.type.title === CustomFieldTypeName.date) {
    return <DateCustomFieldFilterCard {...props} />;
  }
  if (props.customField.type.title === CustomFieldTypeName.plainText) {
    return <PlainTextCustomFieldFilterCard {...props} />;
  }

  return <PublicSelectCustomFieldFilterCard {...props} />;
});

PublicCustomFieldFilterCard.displayName = 'CustomFieldFilterCard';
